<div class="footer mt-3">
  <div class="legal-toggle">
    <div role="button" class="show-legal-indicator {{showLegalMenu ? 'active' : ''}}" (click)="toggleLegalMenuClick()">
      {{localize(langSection.Footer, langText.Legal)}}
    </div>
  </div>
  <div class="footer-info">
    <div class="legal-info {{showLegalMenu ? '' : 'hide-legal'}}">
      <div>
        <a class="text-decoration-none" href="{{localize(langSection.Legal, langText.PrivacyPolicyUrl)}}"
          target="_blank" rel="noopener">{{localize(langSection.Footer, langText.PrivacyPolicy)}}</a>
      </div>
      <div>
        <a class="text-decoration-none" href="{{localize(langSection.Legal, langText.TermsOfServiceUrl)}}"
          target="_blank" rel="noopener">{{localize(langSection.Footer, langText.TermsConditions)}}</a>
      </div>
    </div>
    <div class="copyright-info">
      <div>
        {{localize(langSection.Legal, langText.Copyright)}} &copy; 1994-{{year}}
        {{localize(langSection.Legal, langText.CopyrightDisclaimer)}}
      </div>
    </div>
  </div>
</div>